import { Identifiable, Event } from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";
import { mapError } from "../utils/mapError";

function removeEvent(httpClient: HttpClient) {
  return ({ uuid }: Identifiable<Event>) =>
    httpClient
      .sendHttpRequest({
        endpoint: `/events/${uuid}`,
        method: HttpMethods.DELETE,
      })
      .then(() => Promise.resolve())
      .catch((e) =>
        Promise.reject(
          mapError(e, {
            notFound: "notFound",
          }),
        ),
      );
}

export { removeEvent };
